// extracted by mini-css-extract-plugin
export var hidden = "_sx-0";